import React, { useEffect, useState } from 'react';

export const InlineSvgIcon = ({ src, width = 18, className = '', ...props }) => {
	const [svgContent, setSvgContent] = useState(null);

	useEffect(() => {
		fetch(src).then(res => res.text()).then(setSvgContent);
	}, [src]);

	if (!svgContent) return null;

	return (
		<span
		className={className}
		style={{ width, height: width }}
		dangerouslySetInnerHTML={{ __html: svgContent }}
		{...props}
		/>
	);
};